import {Base,Axios} from "@/api/Base"

export class RemainingVacationExport extends Base {
    path = "remainingVacation/export"
    download(param = {}) {
        return Axios.get(this.path,{ params: param, responseType: "blob" })
    }
}